import React from 'react';
import { 
  HelpCircle, 
  Clock, 
  Coffee, 
  Dumbbell, 
  Utensils, 
  Droplets, 
  Moon,
  Scale,
  Thermometer
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по питанию и подсчету калорий
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Utensils,
      title: 'Качество питания',
      description: 'Выбирайте цельные продукты вместо обработанных. Они более питательны и лучше насыщают.'
    },
    {
      icon: Clock,
      title: 'Режим питания',
      description: 'Регулярность приема пищи помогает контролировать голод и стабилизировать уровень сахара в крови.'
    },
    {
      icon: Dumbbell,
      title: 'Физическая активность',
      description: 'Даже небольшое увеличение активности может значительно влиять на ваш общий расход энергии.'
    },
    {
      icon: Coffee,
      title: 'Учитывайте напитки',
      description: 'Не забывайте про калории из напитков. Сладкие напитки могут добавлять сотни калорий к дневному рациону.'
    },
    {
      icon: Droplets,
      title: 'Питьевой режим',
      description: 'Употребление достаточного количества воды улучшает метаболизм и иногда снижает ощущение голода.'
    },
    {
      icon: Moon,
      title: 'Здоровый сон',
      description: 'Недостаток сна может нарушать гормональный баланс и увеличивать тягу к высококалорийной пище.'
    },
    {
      icon: Scale,
      title: 'Контроль порций',
      description: 'Даже здоровые продукты можно переедать. Обращайте внимание на размеры порций.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-100 dark:border-emerald-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Thermometer className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-emerald-700 dark:text-emerald-300 mb-2">
              Метаболизм жителей России
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400 mb-3">
              В России из-за более холодного климата в среднем базовый метаболизм выше на 5-8% по сравнению с жителями южных стран. Это может требовать небольшой корректировки калорийности рациона.
            </p>
            <p className="text-xs text-emerald-600 dark:text-emerald-400">
              Традиционная русская кухня хорошо адаптирована к этой особенности, содержа больше питательных продуктов с хорошей калорийностью.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;